/* eslint-disable @typescript-eslint/no-explicit-any */
import { OTelService } from "./otel-service";
import { OtelBuilderOptions } from "./types";
import { ITelemetryService } from "./core";

export class OtelBuilder {
  private tracerProviderBuilder?: any;

  private loggerProviderBuilder?: any;

  private readonly serviceName: string;

  private samplingRatio = 1;

  constructor(serviceName: string) {
    this.serviceName = serviceName;
  }

  static create(options: OtelBuilderOptions): OtelBuilder {
    const builder = new OtelBuilder(options.serviceName);
    if (options.samplingRatio !== undefined) {
      builder.withSamplingRatio(options.samplingRatio);
    }
    return builder;
  }

  withSamplingRatio(ratio: number): this {
    this.samplingRatio = ratio;
    return this;
  }

  withTracing(configurator: (builder: any) => void): this {
    this.tracerProviderBuilder = [];
    configurator(this.tracerProviderBuilder);
    return this;
  }

  withLogging(configurator: (builder: any) => void): this {
    this.loggerProviderBuilder = [];
    configurator(this.loggerProviderBuilder);
    return this;
  }

  build(): ITelemetryService {
    const otelService = new OTelService({
      serviceName: this.serviceName,
      samplingRatio: this.samplingRatio,
      otelTracerProvider: this.tracerProviderBuilder,
      otelLoggerProvider: this.loggerProviderBuilder,
    });
    return otelService;
  }
}

export function createOtelBuilder(serviceName: string) {
  return new OtelBuilder(serviceName);
}
